<template>
  <div class="iq-footer">
    <footer class="px-0 py-2">
      <div class="container-fluid">
        <div class="d-flex flex-column flex-md-row  justify-content-md-between">
          <div>
            Copyright 2026 v{{ appVersion }} - All Rights Reserved.
          </div>
          <div>
            <a
              href="https://aljayplantingdreams.com"
              class="font-weight-bold"
              target="company-website"
            >
              Aljay Agro-Industrial Solutions, Inc.
            </a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
// import Vue from 'vue'

export default {
  name: 'Footer',

  computed: {
    appVersion () {
      return process.env.VUE_APP_VERSION
    }
  }
}
</script>
